<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 0.25C5.41333 0.25 0.5 5.16333 0.5 11.25C0.5 17.3367 5.41333 22.25 11.5 22.25C17.5867 22.25 22.5 17.3367 22.5 11.25C22.5 5.16333 17.5867 0.25 11.5 0.25Z"
      fill="white"
    />
    <path
      d="M11.5 0.25C5.41333 0.25 0.5 5.16333 0.5 11.25C0.5 17.3367 5.41333 22.25 11.5 22.25C17.5867 22.25 22.5 17.3367 22.5 11.25C22.5 5.16333 17.5867 0.25 11.5 0.25ZM10.0333 15.8944L5.38889 11.25L7.07558 9.56331L10.0334 12.4966L15.9 6.62998L17.6111 8.31667L10.0333 15.8944Z"
      fill="#4AC7E9"
    />
  </svg>
</template>
<script>
  export default {
    name: "dashboard",
    props: [],
    data: () => ({}),
    mounted() {},
    methods: {},
  };
</script>
